import React from 'react'
import {ReactComponent as Web} from '../../assets/web.svg'
import {ReactComponent as Cart} from '../../assets/cart.svg'
import {ReactComponent as Gear} from '../../assets/gear.svg'
import {ReactComponent as Mobile} from '../../assets/mobile.svg'

const Offer = () => {
    return (
      <div className="boxes">
        <div className="box">
          <div className="box-head">
            <Web fill="#b9b9b9" />
          </div>
          <div className="box-body">
            <h3>Strona internetowa</h3>
            <p>
              Strona internetowa zaprogramowana w&nbsp;pełni responsywnie&nbsp;
              <b>(RWD)</b>, z&nbsp;zachowaniem cech semantycznych. Możliwość
              użycia systemu zarządzania treścią&nbsp;<b>(CMS)</b>
            </p>
          </div>
        </div>
        <div className="box">
          <div className="box-head">
            <Gear fill="#b9b9b9" />
          </div>
          <div className="box-body">
            <h3>Optymalizacja strony WWW</h3>
            <p>
              Mogę zoptymalizować Twoją stronę, dzięki czemu będzie się ładować
              o&nbsp;wiele <b>szybciej</b>. Co&nbsp;ważniejsze, dzięki
              optymalizacji polepszy się wynik w PageSpeed Insights/Lighthouse,
              a także pozycja w <b>Google</b>.
            </p>
          </div>
        </div>
        <div className="box">
          <div className="box-head">
            <Cart />
          </div>
          <div className="box-body">
            <h3>Sklep internetowy</h3>
            <p>
              Sklep internetowy na <b>WooCommerce</b> lub z wykorzystaniem
              prywatnego <b>CMS</b>.
            </p>
          </div>
        </div>
        <div className="box">
          <div className="box-head">
            <Mobile fill="#b9b9b9" />
          </div>
          <div className="box-body">
            <h3>Aplikacja PWA</h3>
            <p>
              Jestem w stanie napisać aplikację internetową, która zapewnia wrażenia dedykowanej aplikacji natywnej. Aplikacja działa jak strona internetowa, jednak dzięki możliwości dodania jej do ekranu głównego swojego urządzenia, działa także <b>offline</b>.
            </p>
          </div>
        </div>
      </div>
    );
}

export default Offer
